import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import { IconModule } from '../icon/icon.module';
import { ChampionsImportComponent } from './components/champions-import/champions-import.component';
import { ChampionsImportXlsxComponent } from './components/champions-import-xlsx/champions-import-xlsx.component';

@NgModule({
  declarations: [
    ChampionsImportComponent,
    ChampionsImportXlsxComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
    IconModule
  ],
  exports: [
    ChampionsImportComponent,
    ChampionsImportXlsxComponent
  ]
})
export class ImportChampionsModule { }
